import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCCarListDetran = class UiCCarListDetran {
    constructor() {
        this.emitVehicle = new EventEmitter();
        this.emitVehicleDelete = new EventEmitter();
    }
    ngOnInit() { }
    selectedVehicle(vehicle) {
        this.emitVehicle.emit(vehicle);
    }
    deleteVehicle(vehicle) {
        this.emitVehicleDelete.emit(vehicle);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCarListDetran.prototype, "listCars", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCarListDetran.prototype, "emitVehicle", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCarListDetran.prototype, "emitVehicleDelete", void 0);
UiCCarListDetran = __decorate([
    Component({
        selector: 'ui-c-car-list-detran',
        template: "<div class=\"car-list\">\n  <h4 class=\"ion-text-center title\">{{'CASH_OUT.DETRAN.LABELS.VEHICLES_REGISTERED'| wlpTranslate}}</h4>\n  <ion-list>\n    <ion-item lines=\"full\" class=\"item-car\" *ngFor=\"let item of listCars\">\n      <ion-label class=\"ion-text-wrap\" (click)=\"selectedVehicle(item)\">\n        <p>\n          <span class=\"span-item\">{{'CASH_OUT.DETRAN.LABELS.DESCRIPTION'| wlpTranslate}}</span> {{item.description}}\n        </p>\n        <p>\n          <span class=\"span-item\">{{'CASH_OUT.DETRAN.LABELS.RENAVAM'| wlpTranslate}}</span> {{item.renavam}}\n        </p>\n        <p>\n          <span class=\"span-item\">{{'CASH_OUT.DETRAN.LABELS.STATE'| wlpTranslate}}</span> {{item.uf}}\n        </p>\n        <p>\n          <span class=\"span-item\">{{'CASH_OUT.DETRAN.LABELS.DATE'| wlpTranslate}}</span> {{item.dateRegister | date: 'dd/MM/yyyy hh:ss' }}\n        </p>\n      </ion-label>\n      <ion-icon (click)=\"deleteVehicle(item)\" slot=\"end\" color=\"danger\" size=\"large\" name=\"trash-outline\"></ion-icon>\n    </ion-item>\n  </ion-list>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCCarListDetran);

let UiCListCarDetranModule = class UiCListCarDetranModule {
};
UiCListCarDetranModule = __decorate([
    NgModule({
        declarations: [UiCCarListDetran],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCCarListDetran]
    })
], UiCListCarDetranModule);

export { UiCCarListDetran, UiCListCarDetranModule };
//# sourceMappingURL=wlp-ui-c-car-list-detran.js.map
